import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
    
    @Injectable()
    export class TicketService {
        ticketInformation = {
            personalInformation: {
                email: '',
                password: '',
                confirmpassword: '',
                vendorType:'',
                VendorName:'',
                gSTIN :'',
                country :'',
                address:'',
                state:'',
                city:'',
                mobile:'',
                panNo:'',
                bankAccountNumber:'',
                iFSCCode:'',
                bankName:''
            },
            seatInformation: {
                class: null,
                wagon: null,
                seat: null
            },
            paymentInformation: {
                cardholderName: '',
                cardholderNumber: '',
                date: '',
                cvv: '',
                remember: false
            }
        };
    
        private paymentComplete = new Subject<any>();
    
        paymentComplete$ = this.paymentComplete.asObservable();
    
        getTicketInformation() {
            return this.ticketInformation;
        }
    
        setTicketInformation(ticketInformation) {
            this.ticketInformation = ticketInformation;
        }
    
        complete() {
            this.paymentComplete.next(this.ticketInformation.personalInformation);
        }
    }
    